<template>
  <div class="main">
    <agora
    :channel="channel"
    :autoStart="false"
    :errorHandler="errorHandler"
    :appid="appid"
    :token="token"
    >
    <agora-video-sender
        customizationPlayer
        @video-ready="handleVideoReady"
        :cameraOff="cameraOff"
    />
    <agora-audio-sender
        ref="audioSender"
        :mute="mute"
        @track-created="handleTrackCreated"
    />
    </agora>

    <!-- Single camera area (no duplicate refs) -->
    <div class="camera-area" :class="playerClass" v-player="localVideoDirective">
      <voice-dot class="voice-dot-local" :mute="mute" :level="level" />
      <mp-button-white class="mp-btn-local" :class="mpClass" @click="handleMpClick" />
      <video-button-white class="video-btn-local" :class="videoClass" @click="handleVideoClick" />
    </div>

    <div class="operation">
      <p class="question">{{ $t('msg_start_meeting') }}</p>

      <b-button
          @click="handleJoin"
          variant="outline-secondary"
          class="btn-join-button"
          :disabled="isJoining"
      >
        <span v-if="isJoining"><b-spinner small /> {{ $t('joining_now') }}</span>
        <span v-else>{{ $t('join_now') }}</span>
      </b-button>

      <b-alert
          variant="warning"
          dismissible
          fade
          :show="!!errorMsg"
          @dismissed="showDismissibleAlert = false"
      >
        {{ errorMsg }}
      </b-alert>
    </div>
  </div>
</template>

<script>
import VoiceDot from "./voice-dot/main.vue";
import MpButtonWhite from "./buttons/mp-button-white";
import VideoButtonWhite from "./buttons/video-button-white";
import { BSpinner, BAlert, BButton } from "bootstrap-vue";

export default {
  name: "Main",
  components: { VoiceDot, BButton, BSpinner, BAlert, MpButtonWhite, VideoButtonWhite },
  props: {
    isJoining: { type: Boolean, default: false },
    errorMsg: { type: [String, null], default: null },
    channel: { type: [String, null], default: null },
    appid: { type: [String, null], default: null },
    token: { type: [String, null], default: null }
  },
  data() {
    return {
      localVideoDirective: null,
      mute: false,
      level: 0,
      cameraOff: false
    };
  },
  computed: {
    mpClass() { return this.mute ? "mp-mute" : "mp-normal"; },
    videoClass() { return this.cameraOff ? "video-mute" : "video-normal"; },
    playerClass() { return this.cameraOff ? "camera-off" : ""; }
  },
  methods: {
    errorHandler() {},
    handleVideoReady(localVideo) {
      this.localVideoDirective = localVideo;
    },
    handleTrackCreated() {
      let id;
      const callback = () => {
        const track = this.$refs.audioSender?.getTrack?.();
        this.level = track?.getVolumeLevel ? track.getVolumeLevel() : 0;
        id = window.requestAnimationFrame(callback);
      };
      id = window.requestAnimationFrame(callback);
      this.$once("hook:beforeDestroy", () => window.cancelAnimationFrame(id));
    },
    handleJoin() {
      this.$emit("join-meeting", {
        channel: this.channel,
        mute: this.mute,
        cameraOff: this.cameraOff
      });
    },
    handleMpClick() { this.mute = !this.mute; },
    handleVideoClick() { this.cameraOff = !this.cameraOff; }
  }
};
</script>

<style scoped>
.btn-join-button {
  display: block;
  margin: 0 auto 10px;
  border-radius: 3em;
  text-align: center;
  background-color: #8b3d97;
  color: #fff;
  font-size: 1em;
  cursor: pointer;
}
@media (min-width: 800px) {
  .camera-area { position: absolute; top: 28vh; left: 8vw; width: 50vw; height: 50vh; }
  .operation { position: absolute; right: 10vw; top: 36vh; width: 24vw; height: 20vh; display:flex; flex-direction:column; align-items:center; justify-content:space-around; }
}
@media (max-width: 800px) {
  .camera-area, .operation { position: relative; }
}
</style>
<style lang="stylus" scoped>
@import "../styles/main/index.styl";
</style>
